import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ServicePointFeatures } from '@deprecated/api-interfaces';
import { AuthGuard } from './auth/auth.guard';
import { LayoutComponent } from './layout/components/layout/layout.component';
import { QueryParamsResolver } from './resolver/query-params.resolver';
import { FeatureGuard } from './shared/guards/feature.guard';
import { ShopTitleResolver } from './visit-e-shop/shop-title.resolver';
import { VisitEShopComponent } from './visit-e-shop/visit-e-shop.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'id/:id',
    redirectTo: 'home/:id',
  },

  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'contact',
        loadChildren: () => import('./contact/contact.module').then((m) => m.ContactModule),
        data: {
          feature: ServicePointFeatures.CONTACT_TILE,
          sectionTitle: 'SERVICEPOINT.CONTACT.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'contact/:deviceId',
        loadChildren: () => import('./contact/contact.module').then((m) => m.ContactModule),
        data: {
          feature: ServicePointFeatures.CONTACT_TILE,
          sectionTitle: 'SERVICEPOINT.CONTACT.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'documents/:deviceId',
        loadChildren: () => import('./documents/documents.module').then((m) => m.DocumentsModule),
        data: {
          feature: ServicePointFeatures.DOCUMENTS_TILE,
          sectionTitle: 'SERVICEPOINT.DOCUMENTS.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'parts',
        loadChildren: () => import('./service/service.module').then((m) => m.ServiceModule),
        data: {
          feature: ServicePointFeatures.SPARE_PART_TILE,
          sectionTitle: 'SERVICEPOINT.SERVICE.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'parts/:deviceId',
        loadChildren: () => import('./service/service.module').then((m) => m.ServiceModule),
        data: {
          feature: ServicePointFeatures.SPARE_PART_TILE,
          sectionTitle: 'SERVICEPOINT.SERVICE.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'notes/:deviceId',
        loadChildren: () => import('@ird/asset-management-notes-feature-notes-ng').then((m) => m.NotesNgModule),
        data: {
          feature: ServicePointFeatures.NOTES_TILE,
          sectionTitle: 'SERVICEPOINT.NOTES.TITLE',
        },
        canActivate: [FeatureGuard, AuthGuard],
      },
      {
        path: 'scan',
        loadChildren: () => import('./scan/scan.module').then((m) => m.ScanModule),
        data: {
          feature: ServicePointFeatures.SCAN_TILE,
          sectionTitle: 'SERVICEPOINT.SCAN.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'services',
        loadChildren: () => import('./service-eloqua/service-eloqua.module').then((m) => m.ServiceEloquaModule),
        data: {
          feature: ServicePointFeatures.SERVICES_TILE,
          sectionTitle: 'SERVICEPOINT.SERVICES_ELOQUA.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'services/:deviceId',
        loadChildren: () => import('./service-eloqua/service-eloqua.module').then((m) => m.ServiceEloquaModule),
        data: {
          feature: ServicePointFeatures.SERVICES_TILE,
          sectionTitle: 'SERVICEPOINT.SERVICES_ELOQUA.TITLE',
        },
        canActivate: [FeatureGuard],
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
        data: {
          sectionTitle: 'SERVICEPOINT.HOME.TITLE',
        },
      },
      {
        path: 'qrassignment',
        loadChildren: () => import('./qr-assignment/qrassignment.module').then((m) => m.QrAssignmentModule),
        data: {
          sectionTitle: 'SERVICEPOINT.QRASSIGNMENT.TITLE',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'assets',
        loadChildren: () => import('./assets/assets.module').then((m) => m.AssetsModule),
        data: {
          feature: ServicePointFeatures.MY_ASSETS_TILE,
          sectionTitle: 'SERVICEPOINT.ASSETS.TITLE',
        },
        canActivate: [FeatureGuard, AuthGuard],
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
        data: {
          sectionTitle: 'SERVICEPOINT.AUTH.TITLE',
        },
      },
      {
        path: 'registration',
        loadChildren: () => import('./registration/registration.module').then((m) => m.RegistrationModule),
        data: {
          sectionTitle: 'SERVICEPOINT.REGISTRATION.TITLE',
        },
      },
      {
        path: 'serial',
        loadChildren: () => import('./serial-number/serial-number.module').then((m) => m.SerialNumberModule),
        data: {
          feature: ServicePointFeatures.SERIAL_NUMBER_SEARCH_TILE,
          pageTitle: 'SERVICEPOINT.SERIAL_NUMBER.TITLE',
        },
        canActivate: [FeatureGuard, AuthGuard],
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./auth/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule),
        data: {
          pageTitle: 'SERVICEPOINT.AUTH.FORGOT_PASSWORD.RESET_PASSWORD_TITLE',
        },
      },
      {
        path: 'warranty/:deviceId',
        loadChildren: () => import('./warranty-extension/warranty-extension.module').then((m) => m.WarrantyExtensionModule),
        data: {
          pageTitle: 'SERVICEPOINT.WARRANTY.ELIGIBLE_WARRANTY_EXTENSION',
        },
      },
      {
        path: 'e-shop/:deviceId',
        component: VisitEShopComponent,
        loadChildren: () => import('./visit-e-shop/visit-e-shop.module').then((m) => m.VisitEshopModule),
        resolve: { pageTitle: ShopTitleResolver },
      },
    ],
    resolve: {
      params: QueryParamsResolver,
    },
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
